import React from 'react'
import { Link } from 'react-router-dom'

function BlogDetails() {
  return (
    <div>
      <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Blog Details</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Blog Details Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="post_details">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/details.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="fas fa-calendar"></i>
                                        15 April 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-details">
                                        <i className="fas fa-user"></i>
                                        Jhon Deo
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-details">
                                        <i className="fas fa-comment"></i>
                                        2
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-details">
                                        <i className="fas fa-thumbs-up"></i>
                                        54
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                        <div className="post_author">
                            <img src="/tm/react/dronyug/assets/images/team/2.png" alt="img" className="image-fit"/>
                            <Link to="blog-grid.html">Vimal Gurjar</Link>
                        </div>
                        <div className="blog_meta">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                            <blockquote className="thm-bg-light"> <span className="quote_icon"> <i className="fa fa-quote-left"></i> </span>
                                <p className="quote_title">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                                <cite className="quote_author">Jhon Doe</cite>
                            </blockquote>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                        </div>
                        <hr/>
                        <div className="post_tags_share">
                            <div className="post_tags">
                                <h6>Tags: </h6>
                                <div className="tags">
                                    <Link to="blog-grid.html">Clothes</Link>
                                    <Link to="blog-grid.html">Kids</Link>
                                    <Link to="blog-grid.html">Life Goods</Link>
                                </div>
                            </div>
                            <div className="post_share">
                                <h6>Share: </h6>
                                <ul className="social">
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-facebook-f"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-twitter"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-behance"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="post_big_author thm-bg-light">
                            <img src="/tm/react/dronyug/assets/images/team/3.png" alt="img" className="image-fit"/>
                            <div className="text">
                                <h5 className="mb-2">Jackie Chan</h5>
                                <p className="mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
                                <ul className="social">
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-facebook-f"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-twitter"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-behance"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                       
                        <div className="post_navigation">
                            <Link to="/blog-details" className="nav_item">Previous</Link>
                            <Link to="/blog-details" className="nav_item">Next</Link>
                        </div>
                       
                        <div className="comment_box">
                            <h5>Reviews [2]</h5>
                            <ul className="comments">
                                <li className="comment">
                                    <article>
                                        <div className="comment_image">
                                            <img src="/tm/react/dronyug/assets/images/team/1.png" alt="img" className="image-fit"/>
                                        </div>
                                        <div className="comment_text">
                                            <h6 className="title">Steven Smith</h6>
                                            <div className="comment_date">10 Jan 2024</div>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                        </div>
                                    </article>
                                    <ul className="comments children">
                                        <li className="comment">
                                            <article>
                                                <div className="comment_image">
                                                    <img src="/tm/react/dronyug/assets/images/team/2.png" alt="img" className="image-fit"/>
                                                </div>
                                                <div className="comment_text">
                                                    <h6 className="title">Vimal Gurjar</h6>
                                                    <div className="comment_date">22 March 2024</div>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                                </div>
                                            </article>
                                        </li>
                                    </ul>
                                </li>
                                <li className="comment">
                                    <article>
                                        <div className="comment_image">
                                            <img src="/tm/react/dronyug/assets/images/team/3.png" alt="img" className="image-fit"/>
                                        </div>
                                        <div className="comment_text">
                                            <h6 className="title">Anna Sum</h6>
                                            <div className="comment_date">20 Fab 2024</div>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                        </div>
                                    </article>
                                </li>
                            </ul>
                        </div>
                        <div className="comment_form">
                            <h5>Leave A Reply</h5>
                            <form className="form_style style_two">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input type="text" name="#" placeholder="Your Full Name" className="form-control form-control-custom" autoComplete="off"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input type="email" name="#" placeholder="Your Email" className="form-control form-control-custom" autoComplete="off"/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <textarea rows="5" name="#" placeholder="Write Message" className="form-control form-control-custom" autoComplete="off"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <button type="submit" className="thm-btn btn-rounded w-100">
                                            <span className="button_title">Leave Comment</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogDetails